module.exports = __webpack_public_path__ + "img/plain_btc.db131088.svg";